"use client";

import { useLocale } from "next-intl";
import { TRUSTPILOT_ENABLED, TRUSTPILOT_BUSINESS_UNIT_ID, getTrustpilotLocale } from "@/lib/trustpilot";

export function TrustpilotBadge() {
	const locale = useLocale();

	if (!TRUSTPILOT_ENABLED || !TRUSTPILOT_BUSINESS_UNIT_ID) {
		return null;
	}

	return (
		<div
			className="trustpilot-widget"
			data-locale={getTrustpilotLocale(locale)}
			data-template-id="5419b6a8b0d04a076446a9ad"
			data-businessunit-id={TRUSTPILOT_BUSINESS_UNIT_ID}
			data-style-height="24px"
			data-style-width="100%"
			data-theme="dark"
		>
			<a href="https://www.trustpilot.com/review/bergdorfbio.com" target="_blank" rel="noopener noreferrer">
				Trustpilot
			</a>
		</div>
	);
}
